import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {Col} from 'react-bootstrap';
import ReactPaginate from 'react-paginate';

const Paginator = ({
  setPageIndex,
  getCanPreviousPage,
  getCanNextPage,
  getPageCount,
  onPageChangeCallback = () => {},
  currentPageIndex
}) => {
  const pageCount = getPageCount();
  const canGetNext = getCanNextPage();
  const canGetPrevious = getCanPreviousPage();

  // This useEffect replicates the accessibility behavior from the old pagination lib (react-pagify)
  useEffect(() => {
    // Prevent ellipsis (break) items from being focusable via tab navigation
    const ellipsis = document.querySelectorAll('.break a');
    ellipsis?.forEach((el) => {
      el.setAttribute('tabindex', '-1');
    });
    
    // Ensure the active page link is focusable
    const active = document.querySelector('.active a');
    active?.setAttribute('tabindex', '0');
  }, [currentPageIndex]);

  if (pageCount <= 1) {
    return null;
  }

  const handlePageChange = ({nextSelectedPage, isBreak, isActive}) => {
    if (isBreak) {
      return false;
    }

    const nextPageIndex = isActive ? currentPageIndex : nextSelectedPage;
    setPageIndex(nextPageIndex);
    onPageChangeCallback();
  }

  return (
    <Col sm={12}>
      <div className='table-paginator'>
        <ReactPaginate
          breakLabel="…"
          forcePage={currentPageIndex}
          nextLabel={canGetNext && 'Next ❯'}
          nextClassName={!canGetNext && 'none'}
          nextLinkClassName="page-link"
          onClick={handlePageChange}
          pageRangeDisplayed={5}
          marginPagesDisplayed={1}
          pageCount={pageCount}
          previousLabel={canGetPrevious && '❮ Previous'}
          renderOnZeroPageCount={null}
          pageLinkClassName="page-link"
          previousClassName={!canGetPrevious && 'none'}
          previousLinkClassName="page-link"
          breakClassName="page-link break"
          activeClassName='active'
          containerClassName="pagination"
        />
      </div>
    </Col>
  );
};

Paginator.propTypes = {
  setPageIndex: PropTypes.func.isRequired,
  getCanPreviousPage: PropTypes.func.isRequired,
  getCanNextPage: PropTypes.func.isRequired,
  getPageCount: PropTypes.func.isRequired,
  currentPageIndex: PropTypes.number.isRequired,
  onPageChangeCallback: PropTypes.func
};

export default Paginator;
